import styles from "./EditScreenCompleteSubmissionHeaderInfoDiv.module.css";

const EditScreenCompleteSubmissionHeaderInfoDiv = ({ lines, lineHeight = 0 }) => {
  return (
    <>
      <div className={styles.main_div}>
        {Array.isArray(lines) &&
          lines.length > 0 &&
          lines.map((item, index) => {
            return (
              <div
                key={index}
                className={styles.text}
                style={{
                  marginBottom: index + 1 !== lines.length ? lineHeight : 0,
                  color: `${index == 2 ? '#C04A62' : ''}`
                }}
              >
                {item}
              </div>
            );
          })}
      </div>
    </>
  );
};

export default EditScreenCompleteSubmissionHeaderInfoDiv;
